import qs from 'qs';

export function urlJoin(...parts: (string | undefined | null)[]): string {
  const normalizedParts = parts
    .filter((p): p is string => !!p) // filter undefined, empty strings
    // .map((p, i) => (i === 0 ? p!.replace(/\/+$/, '') : p!.replace(/^\/+|\/+$/g, '')))
    .map((p, i) => {
      const part = p.trim();
      if (i === 0) {
        // Preserve protocol with double slashes, e.g. polylino:// or http://
        return part.replace(/\/+$/, '').replace(/(:)\/?$/, '$1//');
      }
      // Remove leading and trailing slashes from other parts
      return part.replace(/^\/+|\/+$/g, '');
    })
    .filter((p) => !!p); // filter empty string after possible '/' removal

  if (normalizedParts[0]?.endsWith('://')) {
    return normalizedParts + normalizedParts.splice(1).join('/');
  }

  return normalizedParts.join('/');
}

export const loginRedirect = (origin: string, basePath: string | undefined, subPage: string, redirect?: string) => {
  // even copy pate cause a encoding. Make sure it is not encoded.
  const redirectParam = redirect ? decodeURIComponent(redirect) : undefined;
  return `${urlJoin(origin, basePath, subPage)}?${qs.stringify({ redirect: redirectParam })}`;
};

/**
 *
 * @param origin fulldomain or app url such as polylino://
 * @param basePath in most cases, preview path
 * @param redirect Redirect URL after completing secure login process.
 * @param isNative due to limitation in Auth Service, a different (/login) redirect path will be used
 * @returns
 */
export const createSecureLoginLocalRedirectUrl = (
  origin: string,
  basePath: string | undefined,
  redirect?: string,
  isNative: boolean = false,
) => {
  // TODO a bug in Auth removes paths URL paths.
  if (isNative) {
    return loginRedirect(origin, basePath, '/login', redirect);
  }

  return loginRedirect(origin, basePath, '/login/secure', redirect);
};

export const createLoginLocalRedirectUrl = (origin: string, basePath: string | undefined, redirect?: string) => {
  return loginRedirect(origin, basePath, '/login', redirect);
};
